var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ending-wrap"},[_c('v-layout',{staticClass:"tabs"}),_c('div',{staticClass:"content-wrap"},[_c('transition',{attrs:{"name":"fade"}},[_c('v-layout',{staticClass:"fill-height justify-center align-center"},[_c('v-image',{staticClass:"pb-16",attrs:{"src":"ending_message.png"}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }